var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.14 7.47V5.16H5.33V0H7.67V5.16H12.83V7.47H7.67V12.63H5.33V7.47H0.14Z",
    fill: "#1B2436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconSpinner);
export default __webpack_public_path__ + "static/media/plusIcon_spinner.1821879d4165f4bf181ac1a972ad1d3c.svg";
export { ForwardRef as ReactComponent };